<template>
	<nut-dialog
		title="验证成功"
		:visible="modelValue"
		ok-text="确定"
		@ok="hanldleClose"
		no-cancel-btn
	>
		<div class="row">
			<span class="label">奖项：</span>
			<span class="val">{{ data.name }}</span>
		</div>
		<div class="row">
			<span class="label">中奖时间：</span>
			<span class="val">{{ data.wintime }}</span>
		</div>
		<div class="row">
			<span class="label">有效期：</span>
			<span class="val">{{ data.endtime }}</span>
		</div>
		<div class="row">
			<span class="label">用户昵称：</span>
			<span class="val">{{ data.player }}</span>
		</div>
	</nut-dialog>
</template>

<script>
export default {
	name: 'DeviceStatus',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const hanldleClose = () => {
			emit('update:modelValue', false);
		};
		return {
			hanldleClose,
		};
	},
};
</script>

<style lang="scss" scoped>
.row {
	@include flex-center;
	line-height: 28px;
	font-size: $normal-font-size;

	.val-off {
		color: $error-color;
	}
}
</style>
